import { useEffect, useState, useRef } from "react";
import { use3DEffect } from "../../../hooks/use3DEffect";
import { API } from '../../../api';

export default function WeatherWidget() {
  const ref = useRef(null);
  use3DEffect(ref);

  const [weather, setWeather] = useState(null);
  const CACHE_DURATION = 15 * 60 * 1000; // 15 minutes \\

  useEffect(() => {
    async function getWeather() {
      const cached = localStorage.getItem("weather_capdagde");
      if (cached) {
        const parsed = JSON.parse(cached);
        if (Date.now() - parsed.timestamp < CACHE_DURATION) {
          setWeather(parsed.data);
          return;
        }
      }

      try {
        const lat = 43.28;
        const lon = 3.51;

        const url = `https://api.open-meteo.com/v1/forecast?latitude=${lat}&longitude=${lon}` +
                    `&current=temperature_2m,wind_speed_10m,pressure_msl,cloud_cover,weather_code` +
                    `&timezone=Europe/Paris`;


        const res = await fetch(url);
        if (!res.ok) throw new Error("Erreur API météo");

        const data = await res.json();
        const w = data.current;

        const weatherInfo = {
          ...mapWeather(w),
        };

        localStorage.setItem("weather_capdagde",
          JSON.stringify({
            timestamp: Date.now(),
            data: weatherInfo,
          })
        );

        setWeather(weatherInfo);
      } catch (err) {
        console.error("Erreur météo :", err);

        setWeather({
          description: "Données indisponibles",
          temp: "--",
          wind: "--",
          cloud: "--",
          pressure: "--",
          icon: "cloudy-day-3.svg",
        });
      }
    }

    getWeather();
  }, []);

  if (!weather) return null;

  return (
    <div className="containerM">
      <div ref={ref} className="widget">
        <div className="left">
          <img
            src={`${API.API_LINK}/file/pictures/dataSection/meteo/${weather.icon}`}
            alt="meteo"
            className="icon"
          />
          <h5 className="weather-status">{weather.description}</h5>
        </div>

        <div className="right">
          <h5 className="city">Le Cap d'Agde</h5>
          <h5 className="degree">{weather.temp}°C</h5>
        </div>

        <div className="bottom">
          <div>Vent <span>{weather.wind} km/h</span></div>
          <div>Nuages <span>{weather.cloud}%</span></div>
          <div>Pression <span>{weather.pressure} hPa</span></div>
        </div>
      </div>
    </div>
  );
}


// mapping Meteo \\
function mapWeather(w) {
  const mapping = {
    0:  { text: "Ciel clair",               icon: "day.svg" },
    1:  { text: "Principalement clair",     icon: "cloudy-day-1.svg" },
    2:  { text: "Partiellement nuageux",    icon: "cloudy-day-3.svg" },
    3:  { text: "Ciel couvert",             icon: "cloudy.svg" },

    45: { text: "Brouillard",               icon: "fog.svg" },
    48: { text: "Brouillard givrant",       icon: "fog.svg" },

    51: { text: "Bruine légère",            icon: "rainy-1.svg" },
    53: { text: "Bruine",                   icon: "rainy-2.svg" },
    55: { text: "Bruine forte",             icon: "rainy-3.svg" },

    61: { text: "Pluie légère",             icon: "rainy-4.svg" },
    63: { text: "Pluie",                    icon: "rainy-5.svg" },
    65: { text: "Pluie forte",              icon: "rainy-6.svg" },

    71: { text: "Neige légère",             icon: "snowy-1.svg" },
    73: { text: "Neige",                    icon: "snowy-3.svg" },
    75: { text: "Neige forte",              icon: "snowy-6.svg" },

    95: { text: "Orages",                   icon: "thunder.svg" },
  };

  const selected = mapping[w.weather_code] || {
    text: "Indéterminé",
    icon: "cloudy-day-3.svg",
  };

  return {
    description: selected.text,
    icon: selected.icon,
    temp: w.temperature_2m,
    wind: w.wind_speed_10m,
    cloud: w.cloud_cover,
    pressure: w.pressure_msl,
  };
}
